import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/linkedin-icon-white.svg")